import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Countdown } from "../components";
import { allCourses } from "../data/allcourses";
import { StyledLink } from "../utils/button";
import smilingLady from "../assets/smiling-woman.svg";
import "react-circular-progressbar/dist/styles.css";
import "../styles/courses.css";

const Courses = () => {
  const AllCourses = allCourses.map((course, i) => (
    <Link
      to={`/course/${course.title}`}
      key={course.id}
    >
      <div
        className="allcourses-card"
        key={i}
      >
        <img
          src={course.banner}
          alt="course"
        />
        <div>
          <h4>{course.title}</h4>
          <p>{course.duration}</p>
          <p>{course.price}</p>
        </div>
      </div>
    </Link>
  ));

  return (
    <motion.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0.4 }}
      transition={{ duration: 0.5 }}
      className="courses"
    >
      <section className="hero-courses">
        <div>
          <h1>
            Get access to all <br />
            <span>
              courses now <br /> from $50
            </span>
          </h1>
          <div className="countdown-plans-courses">
            <Countdown />
            <div>
              <StyledLink
                to="/plans"
                className="plan-courses"
              >
                Click Here to Start
              </StyledLink>
            </div>
          </div>
        </div>
        <div>
          <img
            src={smilingLady}
            alt="Smiling Lady"
            className="smiling-lady"
          />
        </div>
      </section>

      <section className="all-courses-container">
        <h2>
          On De<span>mand Co</span>urses
        </h2>
        <div className="all-courses">
          {AllCourses}
          {AllCourses}
          {AllCourses}
        </div>

        {/* To be implemented with react infinite scroll */}

        <h2>Load More Courses</h2>
      </section>
    </motion.main>
  );
};

export default Courses;
